import React from 'react';
import PropTypes from 'prop-types';
import Wrapper from '../../components/wrapper';
import {convertPipeToBrTag} from "../../utils";
import './styles.css';

/**
 * SocialIconsContainerBlock
 */
const SocialIconsContainerBlock = ({
                                     containerId,
                                     containerClass,
                                     links,
                                   }) => {
  return (
    <Wrapper
      containerId={containerId}
      containerClass={containerClass}
    >
      <div className="SocialIconsContainerBlock">
        {(links !== null) ?
          <div className="SocialIconsContainerBlock__container">
            <ul className="SocialIconsContainerBlock__list-ul">
              {links.map((link, index) => {
                return (
                  (link.text !== null || link.text2 !== null || link.src !== null) ?
                    <li key={index}>
                      <SocialIconsContainerBlockLink
                        href={link.href}
                        targetBlank={link.targetBlank}
                        text={link.text}
                        text2={link.text2}
                        src={link.src}
                      />
                    </li>
                    : null
                )
              })}
            </ul>
          </div>
          : null}
      </div>
    </Wrapper>
  )
};
SocialIconsContainerBlock.propTypes = {
  containerId: PropTypes.string,
  containerClass: PropTypes.string,
  links: PropTypes.arrayOf(PropTypes.shape({
    href: PropTypes.string,
    targetBlank: PropTypes.bool,
    text: PropTypes.string,
    text2: PropTypes.string,
    src: PropTypes.string,
  })),
};
SocialIconsContainerBlock.defaultProps = {
  containerId: null,
  containerClass: null,
  links: null,
};
export default SocialIconsContainerBlock;

/**
 * SocialIconsContainerBlockLink
 */
const SocialIconsContainerBlockLink = ({
                                         href,
                                         targetBlank,
                                         text,
                                         text2,
                                         src,
                                       }) => {
  
  const getLinkElement = (element) => {
    if (href !== null) {
      return (
        <a className="SocialIconsContainerBlock__link"
           href={(href !== null) ? href: ''}
           target={(targetBlank === true) ? '_blank': ''}
        >
          {element}
        </a>
      )
    } else {
      return (
        <div className="SocialIconsContainerBlock__box">
          {element}
        </div>
      )
    }
  };
  const getTextElement = () => {
    if (text !== null && text2 !== null) {
      return (
        <span className="SocialIconsContainerBlock__text">
                    <span dangerouslySetInnerHTML={{__html: convertPipeToBrTag(text)}}/>
                    <br/>
                    <span dangerouslySetInnerHTML={{__html: convertPipeToBrTag(text2)}}/>
                </span>
      )
    } else if (text !== null && text2 === null) {
      return (
        <span className="SocialIconsContainerBlock__text">
                    <span dangerouslySetInnerHTML={{__html: convertPipeToBrTag(text)}}/>
                </span>
      )
    } else if (text === null && text2 !== null) {
      return (
        <span className="SocialIconsContainerBlock__text">
                    <span dangerouslySetInnerHTML={{__html: convertPipeToBrTag(text2)}}/>
                </span>
      )
    } else {
      return null;
    }
  };
  return (
    getLinkElement((
        <span>
                {(src !== null) ? <img className="SocialIconsContainerBlock__image" src={src}/>: null}
          {getTextElement()}
            </span>
      ),
    )
  )
};



// WEBPACK FOOTER //
// ./src/containers/social-icons-container-block/index.jsx